/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ErrorMessage } from '../model/errorMessage';
// @ts-ignore
import { PeriodVolumeStatisticDto } from '../model/periodVolumeStatisticDto';
// @ts-ignore
import { VolumeStatisticDto } from '../model/volumeStatisticDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

export interface GetVolumeStatisticRequestParams {
  /** From time for filtering, inclusive. Hour precision, round up. */
  fromTime: string;
  /** To time for filtering, inclusive. Hour precision, round down. */
  toTime: string;
}

export interface GetVolumeStatisticForPeriodsRequestParams {
  /** From times for filtering, inclusive, one per period. Hour precision, round up. */
  fromTime: Array<string>;
  /** To times for filtering, inclusive, one per period, in the same order as fromTime. Hour precision, round down. */
  toTime: Array<string>;
}

@Injectable({
  providedIn: 'root',
})
export class VolumeStatisticControllerService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Gets Volume statistic
   * @endpoint get /v1/volume-statistic
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public getVolumeStatistic(
    requestParameters: GetVolumeStatisticRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<VolumeStatisticDto>>;
  public getVolumeStatistic(
    requestParameters: GetVolumeStatisticRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<VolumeStatisticDto>>>;
  public getVolumeStatistic(
    requestParameters: GetVolumeStatisticRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<VolumeStatisticDto>>>;
  public getVolumeStatistic(
    requestParameters: GetVolumeStatisticRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const fromTime = requestParameters?.fromTime;
    if (fromTime === null || fromTime === undefined) {
      throw new Error('Required parameter fromTime was null or undefined when calling getVolumeStatistic.');
    }
    const toTime = requestParameters?.toTime;
    if (toTime === null || toTime === undefined) {
      throw new Error('Required parameter toTime was null or undefined when calling getVolumeStatistic.');
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/volume-statistic`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<VolumeStatisticDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets Volume statistic for several periods
   * @endpoint get /v1/volume-statistic/periods
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public getVolumeStatisticForPeriods(
    requestParameters: GetVolumeStatisticForPeriodsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<PeriodVolumeStatisticDto>>;
  public getVolumeStatisticForPeriods(
    requestParameters: GetVolumeStatisticForPeriodsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<PeriodVolumeStatisticDto>>>;
  public getVolumeStatisticForPeriods(
    requestParameters: GetVolumeStatisticForPeriodsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<PeriodVolumeStatisticDto>>>;
  public getVolumeStatisticForPeriods(
    requestParameters: GetVolumeStatisticForPeriodsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const fromTime = requestParameters?.fromTime;
    if (fromTime === null || fromTime === undefined) {
      throw new Error('Required parameter fromTime was null or undefined when calling getVolumeStatisticForPeriods.');
    }
    const toTime = requestParameters?.toTime;
    if (toTime === null || toTime === undefined) {
      throw new Error('Required parameter toTime was null or undefined when calling getVolumeStatisticForPeriods.');
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/volume-statistic/periods`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<PeriodVolumeStatisticDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
